var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEncounters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "encounters_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".encounters_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "encounters_svg__st0",
    d: "M123.5 70v54.8M24.5 124.8V70M53.9 124.8H14.5v18.1h119v-18.1H93.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "encounters_svg__st0",
    d: "M54.7 142.9v-9.1h38.6v9.1M60.9 133.8v-9h26.2v9M87.1 124.8V87.9H60.9v36.9M52.4 21.6H24.5l-9.8 16M133.3 37.6l-9.8-16H101M54.2 53.5c0 5.5-4.4 9.9-9.9 9.9-2.9 0-5.5-1.2-7.3-3.2M74 53.5c0 5.5-4.4 9.9-9.9 9.9-2.8 0-5.4-1.2-7.2-3.1M93.8 53.5c0 5.5-4.4 9.9-9.9 9.9-2.8 0-5.4-1.2-7.2-3.1M113.5 53.5c0 5.5-4.4 9.9-9.9 9.9-2.9 0-5.6-1.3-7.4-3.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "encounters_svg__st0",
    d: "M34.5 53.5c0 5.5-4.4 9.9-9.9 9.9s-9.9-4.4-9.9-9.9V37.6h118.6v15.9c0 5.5-4.4 9.9-9.9 9.9-2.9 0-5.5-1.3-7.3-3.2M52.4 37.6V5.1H101v32.5M76.7 13.9v14.5M83.9 21.2H69.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-icon-primary)",
    d: "M66.9 93.9h14.2v24.6H66.9z"
  })));
}
export default SvgEncounters;